import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Input } from "../components/ui/input";
import { ADMIN, formatDetail } from "../lib/adminApi";

export default function AdminLogin() {
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await ADMIN.post("/auth/login", f);
      nav("/admin");
    } catch (ex) {
      setErr(formatDetail(ex.response?.data?.detail) || ex.message);
      setBusy(false);
    }
  };
  return (
    <div className="wrap flex justify-center py-24">
      <form onSubmit={submit} className="panel w-full max-w-sm space-y-4 p-8" data-testid="admin-login-form">
        <Lock className="h-6 w-6 text-[var(--teal)]" />
        <h1 className="text-2xl font-bold">Admin sign in</h1>
        <Input type="email" required placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="h-11" data-testid="admin-email-input" />
        <Input type="password" required placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="h-11" data-testid="admin-password-input" />
        {err && <p className="text-sm text-[var(--orange)]" data-testid="admin-login-error">{err}</p>}
        <button className="btn btn-main w-full" disabled={busy} data-testid="admin-login-submit">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in</button>
      </form>
    </div>
  );
}
